import { joinURL, withTrailingSlash, withLeadingSlash } from 'ufo'
import {
  toPublicLocalePath,
  toPublicLocaleSegment,
} from '@design-system/utils/publicLocalePath'

export const useLocalePath = (r?: any) => {
  if (useRuntimeConfig().public.isFederated) {
    const { countryLocale } = useCountryLocale()
    return (path: string) => {
      if (typeof path === 'string' && path.startsWith('http')) return `${path}`
      const publicLocale = toPublicLocaleSegment(countryLocale.value)
      if (
        path.startsWith(`/${publicLocale}`) ||
        path.startsWith(`/${countryLocale.value.toLowerCase()}`)
      ) {
        return toPublicLocalePath(path)
      }
      const finalUrl = joinURL(publicLocale, path)
      return toPublicLocalePath(`${finalUrl}`)
    }
  }
  const route = r ?? useRoute()
  const internalLocale = route.params?.locale as string | undefined
  const publicLocale = internalLocale
    ? `/${toPublicLocaleSegment(internalLocale)}`
    : '/'
  const internalLocalePrefix = internalLocale ? `/${internalLocale}` : '/'
  return (path: string) => {
    if (typeof path === 'string' && path.startsWith('http')) return path
    const leadPath = withLeadingSlash(path)
    if (
      leadPath.startsWith(publicLocale) ||
      leadPath.startsWith(internalLocalePrefix)
    ) {
      return withTrailingSlash(toPublicLocalePath(leadPath))
    }
    const finalUrl = joinURL(publicLocale, path)
    return withTrailingSlash(toPublicLocalePath(`${finalUrl}`))
  }
}
